// @ts-nocheck

import UserOutlined from '@ant-design/icons/UserOutlined';
import SmileOutlined from '@ant-design/icons/SmileOutlined'

export default {
  UserOutlined,
SmileOutlined
}
    